import React, { useEffect, useState } from 'react';
import './style.scss';
import clsx from 'clsx';

interface PepeData {
  position: [number, number];
  scale: number;
  speedX: number;
  speedY: number;
  mirrored: boolean;
}

const random = (low: number, high: number, float: boolean = false): number => {
  const raw = Math.random() * (high - low) + low;
  if (!float) return Math.round(raw);
  return Number(raw.toFixed(2));
};

const getRandomData = (): PepeData => {
  const scale = random(0.5, 1.7, true);
  const size = 200 * scale;
  const vw = Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0,
  );
  const vh = Math.max(
    document.documentElement.clientHeight || 0,
    window.innerHeight || 0,
  );
  const x = random(1, vw - size - 1);
  const y = random(1, vh - size - 1);
  const speedX = random(20, 45) * (random(0, 2) - 1 || 1);
  const speedY = random(20, 45) * (random(0, 2) - 1 || 1);
  return {
    scale,
    position: [x, y],
    speedX,
    speedY,
    mirrored: speedX < 0,
  };
};

const Pepe = () => {
  const [data, setData] = useState<PepeData>(getRandomData());

  useEffect(() => {
    const vw = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0,
    );
    const vh = Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0,
    );
    const scaleLimit = vw > 600 ? 1.7 : 1;
    let sizeCounter = 1;
    let speedCounter = 1;
    const interval = setInterval(() => {
      setData((prev) => {
        let newScale = prev.scale;
        if (sizeCounter >= 10) {
          sizeCounter = 0;
          newScale = random(
            Math.max(0.5, prev.scale - 0.4),
            Math.min(scaleLimit, prev.scale + 0.4),
            true,
          );
        }
        let newSpeedX = prev.speedX;
        let newSpeedY = prev.speedY;
        if (speedCounter >= 50) {
          speedCounter = 0;
          newSpeedX =
            random(
              Math.max(20, Math.abs(prev.speedX) - 20),
              Math.min(45, Math.abs(prev.speedX) + 20),
            ) * (prev.speedX >= 0 ? 1 : -1);
          newSpeedY =
            random(
              Math.max(20, Math.abs(prev.speedY) - 20),
              Math.min(45, Math.abs(prev.speedY) + 20),
            ) * (prev.speedY >= 0 ? 1 : -1);
        }
        let newPositionX = prev.position[0] + newSpeedX;
        let newPositionY = prev.position[1] + newSpeedY;
        const size = 200 * newScale;
        if (newPositionX + size >= vw) {
          newPositionX = Math.min(prev.position[0], vw - size - 1);
          newSpeedX = -newSpeedX;
        }
        if (newPositionY + size >= vh) {
          newPositionY = Math.min(prev.position[1], vh - size - 1);
          newSpeedY = -newSpeedY;
        }
        if (newPositionX <= 0) {
          newPositionX = Math.max(prev.position[0]);
          newSpeedX = -newSpeedX;
        }
        if (newPositionY <= 0) {
          newPositionY = Math.max(prev.position[1]);
          newSpeedY = -newSpeedY;
        }
        sizeCounter += 1;
        speedCounter += 1;
        return {
          scale: newScale,
          position: [newPositionX, newPositionY],
          speedY: newSpeedY,
          speedX: newSpeedX,
          mirrored: newSpeedX < 0,
        };
      });
    }, 100);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className='pepe-wrapper'
      style={{
        transform: `translateX(${data.position[0]}px) translateY(${data.position[1]}px)`,
      }}
    >
      <div
        className='pepe-size-wrapper'
        style={{ transform: `scale(${data.scale})` }}
      >
        <img
          src='/assets/pepe.gif'
          className={clsx('pepe', data.mirrored && 'mirrored')}
        />
      </div>
    </div>
  );
};

export default Pepe;
